import { useState } from 'react'

import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { Checkbox, DialogActions, DialogContent, FormControlLabel, IconButton, TextField } from '@mui/material'

import { toast } from "react-toastify"

import './dialogStyle.css'
import iconAnular from './iconAnular.svg'
import { Model } from '../../../models/model'

export const DialogAnular = ({ setForm, dataForm, open, setOpen, checkInitialData }) => {

    const [formAnular, setFormAnular] = useState({
        id: dataForm.id,
        anulada_con_nc: false,
        anulada_numero_nc: '',
    })

    // console.log({ formAnular })

    const handleAnular = async () => {
        if (formAnular?.anulada_con_nc && (formAnular?.anulada_numero_nc === '' || formAnular?.anulada_numero_nc === null)) {
            toast.warning('Falta ingresar número de Nota de crédito')
            return false
        }

        await Model.update({
            url: `invoices/nullify/${dataForm.id}`,
            dataForm: formAnular
        })

        await checkInitialData(dataForm.id)
        setOpen(false)

    }

    const handleChange = (e) => {
        const { name, value, checked } = e.target
        setFormAnular({
            ...formAnular,
            [name]: (name === 'anulada_con_nc' ? checked : value)
        })
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>
                    <img src={iconAnular} alt="arrow" />
                </div>
                <div className='text mt-3'>
                    Confirmar anulación
                </div>

                <div className='text-center mt-2'>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="anulada_con_nc"
                                onChange={handleChange}
                                checked={formAnular?.anulada_con_nc || false}
                                style={{ color: '#8E24AA' }}
                            />
                        }
                        label="Anular con Nota de crédito"
                    />
                    {formAnular?.anulada_con_nc ?
                        <TextField
                            label="Número nota de crédito"
                            name="anulada_numero_nc"
                            id="outlined-size-small"
                            value={formAnular?.anulada_numero_nc || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese Nro. Nota de crédito'
                            onChange={handleChange}
                        /> : ''
                    }
                </div>

                <p className='p-text-emisor' style={{ fontSize: '12px' }}>Esta acción descontará el monto faturado del proyecto.</p>
            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='approve' onClick={handleAnular}>Sí. Anular</button>
            </DialogActions>
        </Dialog>
    );

}